import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    bold: {
        fontWeight: 600,
    },
    list: {
        margin: '4px',
    },
    listSubheader: {
        paddingBottom: '8px',
        paddingTop: '8px',
        background: theme.palette.grey[theme.palette.type === 'dark' ? 900 : 300],
        fontWeight: 'bold',
        fontSize: '18px',
        lineHeight: '18px',
    },
    secondaryText: {
        fontSize: theme.textField.textFontSize,
        color: theme.textField.textColor,
        fontWeight: 'normal',
    },
}));
